// Aviso de «hay más abajo»: una flecha flotante, pegada al borde derecho del
// panel, que se ve mientras quede suficiente panel debajo de lo que cabe en la
// pantalla. Nació para la semana elegida —elegir una recarga la página desde
// arriba y su detalle cae fuera de la vista— pero vale para todo lo que el
// panel tenga abajo.
//
// Nace oculta en el HTML: sin JS la página queda como siempre.

// «Suficiente»: al menos un cuarto de ventana de panel escondido abajo. Con
// menos, lo que falta se alcanza a intuir y la flecha sería ruido.
const SUFICIENTE = 0.25
// Separación entre la flecha y el borde derecho del panel, en px.
const MARGEN = 16
// La misma que transition-opacity duration-500 en el HTML.
const DESVANECIDO_MS = 500

export function initAvisoAbajo() {
  const aviso = document.querySelector("[data-aviso-abajo]")
  const panel = document.querySelector("[data-aviso-abajo-panel]")
  if (!aviso || !panel) return

  let visible = false
  let apagado = null // temporizador del desvanecido en curso
  let programado = false

  const quedaAbajo = () => panel.getBoundingClientRect().bottom - window.innerHeight

  // Fija en la ventana, pero alineada al panel y no a la pantalla: en una
  // pantalla ancha el panel queda al centro y la orilla de la ventana, lejos.
  const alinear = () => {
    const hueco = document.documentElement.clientWidth - panel.getBoundingClientRect().right
    aviso.style.right = `${Math.max(hueco, 0) + MARGEN}px`
  }

  const mostrar = () => {
    clearTimeout(apagado)
    alinear()
    aviso.hidden = false
    // Pedir el ancho obliga al navegador a calcular la flecha todavía
    // transparente; sin eso junta los dos cambios y aparece de golpe, sin
    // transición. No depende de cuadros de animación, que el navegador retrasa
    // o detiene cuando la pestaña no está al frente.
    void aviso.offsetWidth
    aviso.classList.remove("opacity-0")
  }

  const esconder = () => {
    aviso.classList.add("opacity-0")
    apagado = setTimeout(() => { aviso.hidden = true }, DESVANECIDO_MS)
  }

  const actualizar = () => {
    programado = false
    const hayQueMostrar = quedaAbajo() >= window.innerHeight * SUFICIENTE
    if (hayQueMostrar === visible) {
      if (visible) alinear()
      return
    }
    visible = hayQueMostrar
    if (visible) mostrar()
    else esconder()
  }

  // Un cálculo por cuadro, por más eventos de scroll que lleguen.
  const programar = () => {
    if (programado) return
    programado = true
    requestAnimationFrame(actualizar)
  }

  window.addEventListener("scroll", programar, { passive: true })
  window.addEventListener("resize", programar, { passive: true })
  // Las fotos cambian el alto del panel cuando terminan de cargar.
  window.addEventListener("load", programar)

  aviso.querySelector("[data-aviso-abajo-ir]").addEventListener("click", () => {
    const behavior = window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth"
    const detalle = document.getElementById("detalle-semana")
    // Si la semana elegida sigue abajo, a eso se venía; si no, una pantalla más.
    if (detalle && detalle.getBoundingClientRect().top > window.innerHeight * 0.8) {
      detalle.scrollIntoView({ behavior, block: "start" })
    } else {
      window.scrollBy({ top: window.innerHeight * 0.8, behavior })
    }
  })

  // Con un ancla en la URL (#detalle-semana, al volver de guardar) el navegador
  // todavía va a bajar: decidir antes haría parpadear la flecha. Decide el load.
  if (location.hash && document.readyState !== "complete") return
  actualizar()
}
